import React, { Component } from 'react';
import Toggle from 'material-ui/Toggle';
import { FieldTitle } from 'admin-on-rest';

const styles = {
  block: {
    margin: '1rem 0',
    maxWidth: 250,
  },
  label: {
    color: 'rgba(0, 0, 0, 0.298039)',
  },
  toggle: {
    marginBottom: 16,
  },
};

class BooleanInput extends Component {
  handleToggle = (event, value) => {
    this.props.input.onChange(value);
  };

  render() {
    const {
      input,
      isRequired,
      label,
      source,
      elStyle,
      resource,
      options,
    } = this.props;

    return (
      <div style={elStyle || styles.block}>
        <Toggle
          toggled={!!input.value}
          onToggle={this.handleToggle}
          labelStyle={styles.label}
          style={styles.toggle}
          label={
            <FieldTitle
              label={label}
              source={source}
              resource={resource}
              isRequired={isRequired}
            />
          }
          {...options}
        />
      </div>
    );
  }
}

BooleanInput.defaultProps = {
  addField: true,
  options: {},
};

export default BooleanInput;



// WEBPACK FOOTER //
// ./src/components/BooleanInput.js